export default "__VITE_ASSET__ffd9b989__"